<template>
    <div>
        <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Evaluación de atmósferas</h1>    
            <h2 class="animated bounceIn dura-2">Prueba final </h2>
      </v-flex>
            <v-flex xs12 sm9 md7 mt-3 class="text-xs-left" v-if="!startQuiz">
                <p class="animated fadeIn dura-2">A continuación, encontrarás una serie de preguntas, para que respondas con base en los conocimientos construidos en este módulo. 
                </p>
                <p class="animated bounceIn dura-4"><strong>Contesta únicamente aquellas preguntas en las que tienes seguridad de respuesta.</strong>Si tu respuesta no es correcta, te invitamos a buscar la estrategia que consideres adecuada para obtener un nivel de excelencia. </p>
                <p class="animated fadeIn dura-6">La prueba consta de diez (10) preguntas que pueden ser de selección múltiple con única respuesta o de opción Falso- Verdadero. </p>
                <p class="fb-italic tituloUnidad animated bounceIn dura-7">Haz clic en el botón para iniciar</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-3 class="text-xs-center animated fadeIn dura-7" v-if="!startQuiz">
                <button class="mt-1 animated fadeInUp" @click="startQuiz = true">
                    <img class="mt-1 animated fadeInUp" src="@/assets/presentacion/4 boton inicio portada.svg"
                        alt="monitoreo">
                </button>
    
            </v-flex>
             <v-flex xs12 sm9 md7 mt-3 class="text-xs-left" v-if="startQuiz">
                <p class="animated fadeIn"> Lee detenidamente cada pregunta, identifica la respuesta correcta y márcala según corresponda.</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-1 v-if="startQuiz">
                <div v-for="(pregunta, index) in data.preguntas" :key="index" v-show="pre == (index+1)" class="text-xs-left animated fadeInLeft">
                    <span class="fb-semibold tit-prgunta"> Pregunta {{index+1}}</span> <br>
                    <img v-if="pre === 4" class="img-fluid" src="@/assets/unidad1/pregunta-4.png" alt="">
                    <img v-if="pre === 10" class="img-fluid" src="@/assets/unidad1/pregunta-10.png" alt="">
                    <ul class="mt-3 list-preguntas"> <span v-html="pregunta.titulo"></span>
                        <li v-for="(option, index) in pregunta.options" :key="'option'+index"
                            @click="comprobar(option.id, pregunta.correct)" :class="{'noclick':noClick}">
                            <span v-html="'<strong>'+option.id+'</strong>). '+ option.opt"></span>
                        </li>
                    </ul>
                </div>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-1 class="text-xs-left" v-if="startQuiz">
                <button type="button" @click="comprobar('true','false')">
                <svgmod class="mt-1 animated fadeInUp"></svgmod>
                                </button>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-1 class="retroalimentacion animated bounceIn" :class="retroalimentacion ? 'retro-bien':'retro-mal'" v-if="verretro">
                <p v-if="retroalimentacion"><span><img class="icono" src="@/assets/imagenes_compartidas/13-icono-retroalimentacion-BIEN.png" alt=""></span> ¡Muy bien! Has respondido correctamente.</p>
                <p v-if="!retroalimentacion"><span><img class="icono" src="@/assets/imagenes_compartidas/14-icono-retroalimentacion-MAL.png" alt=""></span> No es la respuesta correcta.</p>
            </v-flex>
            <v-flex xs12 sm9 md7 mt-2 v-if="todosvistos" class="animated fadeInUp">
                <h2>¡Has finalizado la prueba!</h2>
                <p>Preguntas respondidas correctamente:</p>
            </v-flex>
            <v-flex xs12 sm12 md12></v-flex>
            <v-flex xs12 sm9 md4 mt-2 v-if="todosvistos" class="animated fadeInUp resultado">
                <h2>{{numcorrectas}} de {{this.data.preguntas.length}}</h2>
            </v-flex>
            <v-flex xs12 sm12 md12></v-flex>
            <v-flex xs12 sm9 md7 mt-3 v-if="todosvistos" class="animated fadeInUp dura-2">
                
                <button @click="reiniciar()" class="hvr-scale"><img  src="@/assets/unidad2/boton Nuevamente.svg" alt=""></button> 
                <!-- <p>Continúa con el desarrollo del curso para profundizar en diferentes temas muy importantes sobre la medición de atmósferas.</p> -->
            </v-flex>
        </v-layout> 
    </div>
</template>

<script>
import resourcesLoader from "../../js/mixins/resources-loader"
import nextConditions from "../../js/mixins/nextConditions"
import svgmod from "./svg/mod2"
export default {
    components: {
        svgmod
    },
    mixins: [resourcesLoader, nextConditions],
    data() {
        return {
            dialogos: [
                'Antes de empezar, responde la siguiente evaluación de conocimientos previos. <span class="instruccion">Selecciona la respuesta correcta.<span>'
            ],
            verretro: false,
            retroalimentacion: false,
            todosvistos: false,
            pre: 1,
            numpreguntas: 0,
            data: '',
            vistos: '',
            numcorrectas: 0,
            noClick: false,
            startQuiz: false,
        }
    },
    created() {
        // this.$store.commit('vistosUnidad1Mod31', false)
        // this.$store.commit('vistosUnidad1Mod32', false)
        // this.$store.commit('vistosUnidad1Mod33', false)
        // this.$store.commit('vistosUnidad1Mod34', false)
        // this.$store.commit('vistosAllMod3', false)
        this.getJson('datajson/unidad1/mod1-1', data => {
            this.data = data
            var countpreguntas = this.data.preguntas.length
            this.vistos = Array(countpreguntas).fill(false)
        })
        console.log(this.$store.state.evamoduno)
    },
    methods: {
        reiniciar(){
            this.numpreguntas = 0
            this.startQuiz =false
            this.todosvistos = false
            this.verretro= false
            this.numcorrectas=0
            this.pre=1
            this.noClick=false
        },
        comprobar(val, rest) {
            this.verretro = true;
            this.$set(this.vistos, this.numpreguntas, true);
            this.numpreguntas++;
            this.noClick = true;
            setTimeout(() => {
                this.pre++;
                this.verretro = false;
                this.noClick = false;
                if (this.pre > this.data.preguntas.length) {
                    this.pre = this.data.preguntas.length;
                    this.noClick = true;
                    this.todosvistos = true;
                    this.$store.state.evamoduno = this.numcorrectas;
                }
            }, 100);
            if (val == rest) {
                this.retroalimentacion = true
                this.numcorrectas++
            } else {
                this.retroalimentacion = false
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;
    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}
.container-module {
    text-align: left;
    p {
        margin: 0;
        padding: 0;
    }
    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }
    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }
    @media screen and (max-width: 500px) {
        text-align: center;
        img {
            width: 40%;
        }
        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}

ul {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
        padding-left: 10px;
        margin-top: 3px;
        margin-left: 0;
    }
}

.tit-prgunta {
    font-size: 14pt;
    color: $color-primary;
}

.retroalimentacion {
    width: 100%;
    border: solid 2px;
    margin-top: 20px;
    text-align: center;
    p {
        margin: 0;
        padding: 0;
        font-family: FontBase-BoldItalic;
        display: flex;
        align-items: center;
        justify-content: start;
        .icono {
            margin-right: 0.5em;
        }
    }
}

.retro-bien {
    border-color: $color-success;
}

.retro-mal {
    border-color: $color-danger;
}

.list-preguntas {
    font-family: FontBase-Bold;
    li {
        margin: 3px 0px;
        border: solid transparent 1px;
        padding: 3px 4px;
        cursor: pointer;
        font-family: FontBase-Regular;
        &:hover {
            background: #F4F4F4;
            border: solid gray 1px;
        }
    }
}

.resultado {
    border: dashed $color-secondary 2px;
    padding: 5px 0px;
}

.btn-quiz {
    background: #F4F4F4;
    &:hover {
        background: $color-secondary;
    }
}

ol {
    font-size: 1em;
    text-align: left;
    color: $color-text;
}

ol {
    li {
        font-size: 0.85em;
        text-align: left;
        color: $color-text;
        line-height: 120%;
    }
}

ul {
    li {
        font-size: 0.85em;
        text-align: left;
        color: $color-text;
        line-height: 120%;
    }
}

</style>